<template lang="pug">
div
  .current-time-line(v-if="showTimeLine" title="Current time" :style="`width: ${timeslotHolderWidth}px; transform: translateY(${currentTimeLinePosition}px)`") 
    span.current-time {{ timeNow }}
  .time-labels-holder(:style="`transform: translateX(${getScrollPosTimes}px);`" :class="timeLabelsBorderAndShadow")
    .time-label(v-for="(i,index) in timeColumns" :key="index") {{ i.time }}
  .times-holder(:style="`width: ${timeslotHolderWidth}px`")
    .time-columns(v-for="(i,index) in timeColumns" :key="index") 
      .cells.flex
        .cell(v-for="resource in resources") 
</template>
<script>
import {
  getCurrentTimeLinePosition,
  getTimeColumns,
} from '@/vue/planboard/planboard-calendar/planboardCalendarUtil.js'
import { formatTime } from '@/helpers/dateTimeFormatter.js'
import { utcToZonedTime } from 'date-fns-tz'

export default {
  name: 'Times',
  props: {
    resources: Array,
    timeslotHolderWidth: Number,
    openingDateTime: String,
    scrollPosTimes: Number,
  },
  computed: {
    getScrollPosTimes() {
      return this.scrollPosTimes > 40 ? this.scrollPosTimes - 40 : 0
    },
    timeColumns() {
      return getTimeColumns(this.openingDateTime, this.$locale, this.$timezone)
    },
    timeNow() {
      return formatTime(this.$locale)(this.timeNowInZonedTime).substring(0, 5)
    },
    currentTimeLinePosition() {
      return getCurrentTimeLinePosition(this.timeNowInZonedTime, this.openingDateTimeInZonedTime)
    },
    showTimeLine() {
      const firstDateTime = this.timeColumns[0].date
      const lastDateTime = this.timeColumns[this.timeColumns.length - 1].date
      return firstDateTime < this.timeNowInZonedTime && this.timeNowInZonedTime < lastDateTime
    },
    timeLabelsBorderAndShadow() {
      return this.scrollPosTimes > 0 ? 'border-and-shadow' : ''
    },
    openingDateTimeInZonedTime() {
      return utcToZonedTime(this.openingDateTime, this.$timezone)
    },
    timeNowInZonedTime() {
      return utcToZonedTime(new Date(), this.$timezone)
    },
  },
  methods: {
    scrollToCurrentTime() {
      if (this.showTimeLine)
        this.$document.getElementById('planboard-calendar').scroll({
          top: this.currentTimeLinePosition - 100,
          behavior: 'smooth',
        })
    },
  },
  mounted() {
    this.scrollToCurrentTime()
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.current-time-line
  border-top 1px solid colorRed
  position absolute
  margin-left 90px
  z-index 5
  cursor default

  .current-time
    position absolute
    left -50px
    top -15px
    font-size 12px
    line-height 16px
    background-color colorRed
    color white
    padding 5px
    border-radius 5px
    width 50px
    text-align center

.time-labels-holder
  position absolute
  width 90px
  text-align end
  margin-top -7px
  background #eff3f7
  z-index 2
  padding-right 10px
  transition transform 0.3s

  .time-label
    height 60px
    font-size 12px
    line-height 16px
    color grey700

.border-and-shadow
  border-right 1px solid grey300
  -webkit-box-shadow 3px 1px 5px 1px grey300
  box-shadow 3px 1px 5px 1px grey300

.times-holder
  position relative
  margin-left 90px

  .time-columns
    border-width 1px 0px 0px 1px
    border-style solid
    border-color grey300
    height 60px
    position relative

    .cells
      margin-left -1px

      .cell
        width 220px
        border-width 0px 0px 0px 1px
        border-style solid
        border-color grey300
        height 60px

      :last-of-type
        border-width 0px 1px 0px 1px
</style>
